import axios from 'helpers/axios';

export const getResidenceRegions = async () => {
    const { data } = await axios.get(`/api/adminapi/residenceregions/`);

    return data;
};
